import { makeStyles } from "@material-ui/core"

export const vendorDetachedEmailDialogStyle = makeStyles((theme) => ({
    fieldLabel: {
        fontWeight: 'bold',
        marginBottom: '0.25em',
        color: theme.palette.primary.dark,
    },
    fieldValue: {
        marginBottom: '1em',
        wordBreak: 'break-word',
    },
    bodyPreview: {
        marginBottom: '1em',
        padding: '0.5em',
        border: '1px solid #ddd',
        borderRadius: '4px',
        backgroundColor: '#fafafa',
        minHeight: '4em',
    },
}));
